import DialogComponent from "components/Dialog";

export default class DeleteFamilyDialog extends DialogComponent {

    title = "client.relativeDel";

    show(info, hideCb) {
        this.info = info;
        this.hidCb = hideCb;
        this.dialogSaveLabel = "client.delete";

        super.show();
    }

    async save() {
        this._helper.showLoading();

        const resp = await this._request.clientRelations.delete(this.info.id);

        this._helper.hideLoading();

        if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
        }
    }

    renderContent() {
        const { client } = this.info;

        return (
            <div className="content text p1">
                {`${this.tr("client.approvDelRel")} ${this._helper.string.formatFullName(client)}`}
            </div>
        );
    }
}
